import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export interface CloneApiPayload {
  newName: string;
}

export interface CloneApiResponse {
  id: string;
  url: string;
  method: string;
}

export async function cloneApi(
  projectUuid: string, 
  selectedApiId: string, 
  label: string,
  payload: CloneApiPayload,
  token: string
): Promise<CloneApiResponse> {
  const url = `${config.isometricApiUrl}/functional-graph/${projectUuid}/clone-node/${selectedApiId}/${label}`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error cloning api:", error);
    throw error;
  }
}

export const useCloneApi = (
  onSettled?: (res: CloneApiResponse | undefined, error: Error | null) => void
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
      projectUuid: string;
      selectedApiId: string;
      label: string;
      body: CloneApiPayload;
    }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace('Bearer ', '');
      return cloneApi(payload.projectUuid, payload.selectedApiId, payload.label, payload.body, token);
    },
    onSettled
  });
};